/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_DescInputs */

const en_builder_plan_desc = /** @type {(inputs: Builder_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For non-programmers: Bystep writes a short plan, builds it step by step and publishes it.`)
};

const id_builder_plan_desc = /** @type {(inputs: Builder_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk yang bukan programmer: Bystep menyusun rencana ringkas, membangun langkah demi langkah, dan menerbitkannya.`)
};

/**
* | output |
* | --- |
* | "For non-programmers: Bystep writes a short plan, builds it step by step and publishes it." |
*
* @param {Builder_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_desc = /** @type {((inputs?: Builder_Plan_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_desc(inputs)
	return en_builder_plan_desc(inputs)
});